import i18n from '@/i18n';
import translateGeneral from '@/services/validation/translator';
import erreurChampsVide from '@/services/validation/erreurChampsVide';
import { erreurStringLength, STRING_LENGTH } from '@/services/validation/erreurStringLength';

export function removeDuplicateMsgError(messages) {
  if (!Array.isArray(messages) || !messages.length) return [];
  const copieMessages = messages.map(msg => ({ msg, id: i18n.t(msg.message, msg.parametres) }));
  const uniqueIds = [...new Set(copieMessages.map(el => el.id))];
  return uniqueIds.map(id => copieMessages.find(el => el.id === id).msg);
}

export default function validation(i18n, response, messages, champsVide, messagesChampsVide,
  translate) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors) {
    if (response.data && response.data.error && response.data.error.message === 'Exception of type \'Abp.Domain.Entities.EntityNotFoundException\' was thrown.') {
      messages.push({ message: 'validation.notAccess' });
    }
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    let champs = 0;
    if (error.members) {
      champs = error.members[0];
      if (translate) champs = translate(i18n, champs);
      champs = translateGeneral(i18n, champs);
    }
    const message = error.message;
    if (!message || message.endsWith(' field is required.')
      || message.startsWith('Cannot convert null')
      || message.startsWith('Error converting value {null}')) {
      erreurChampsVide(champsVide, champs, messagesChampsVide);
    }
    if (message.indexOf(STRING_LENGTH) !== -1 && champs) {
      erreurStringLength(message, champs, messages);
    }
  });
}



// WEBPACK FOOTER //
// ./src/services/validation/validation.js